export default __webpack_public_path__ + "media/components/AdEdit/images/android-template-86a42b70220b248737977ae6f6153b0f.png";